import gsap, { Circ, Quint, Expo } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

const recruit = () => {
  const target = document.querySelector('.is-recruit')

  if (target) {
    const bgItems = document.querySelectorAll('.recruit-bg__container > *')
    const heroBg = document.querySelector('.section-hero .headline-bg')

    let progress = 0

    if(heroBg) {
      gsap.set(heroBg, {
        clipPath: 'polygon(0 0, 101% 0, 101% 101%, 0 101%)',
      })

      gsap.timeline()
      .to(heroBg, {
        clipPath: 'polygon(0 101%, 101% 101%, 101% 101%, 0 101%)',
        ease: 'expo.inOut',
        duration: 1,
        onStart: function() {
          setTimeout(() => {
            ScrollTrigger.create({
              trigger: '.section-hero .content',
              start: 'top bottom-=65px',
              endTrigger: '.site-main',
              end: 'bottom-=65px bottom-=65px',
              onUpdate: (self) => {
                if (progress < self.progress) {
                  progress = self.progress
                  gsap.to(bgItems, {
                    scaleY: progress,
                    ease: Expo.easeOut,
                    duration: 1.6,
                    stagger: 0.12,
                  })
                }
              },
              onLeave: (self) => self.kill()
            })
          }, 300);
        }
      })
    } else {
      ScrollTrigger.create({
        trigger: '.section-hero .content',
        start: 'top bottom-=65px',
        endTrigger: '.site-main',
        end: 'bottom-=65px bottom-=65px',
        onUpdate: (self) => {
          if (progress < self.progress) {
            progress = self.progress
            gsap.to(bgItems, {
              scaleY: progress,
              ease: Expo.easeOut,
              duration: 1.4,
              stagger: 0.05,
            })
          }
        },
        onLeave: (self) => self.kill()
      })
    }
  }
}

export default recruit